import React from 'react';
import { useIdleTimerContext } from '../contexts/IdleTimerContext';
import { useAuth } from '../hooks/useAuth';

/**
 * SessionTimeoutModal Component
 * Displays a warning modal when the user session is about to timeout
 * Shows a countdown timer and allows the user to confirm they want to stay logged in
 */
const SessionTimeoutModal: React.FC = () => {
  const { isPromptOpen, remainingTime, confirmActivity } = useIdleTimerContext();
  const { user } = useAuth();
  
  // Only show the modal if user is authenticated and prompt is open
  if (!user || !isPromptOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 m-4 max-w-md w-full">
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900">Session Timeout Warning</h3>
          <p className="mt-2 text-sm text-gray-500">
            Your session is about to expire due to inactivity.
          </p>
        </div>

        <div className="mb-6 flex flex-col items-center">
          <div className="text-4xl font-bold text-[#F55D3E] mb-2">
            {remainingTime}
          </div>
          <p className="text-sm text-gray-600">seconds remaining</p>
        </div>

        <p className="mb-4 text-sm text-gray-600">
          Click the button below to continue your session, or you will be automatically logged out.
        </p>

        <div className="flex justify-center">
          <button
            onClick={confirmActivity}
            className="px-4 py-2 bg-[#F55D3E] text-white rounded-md hover:bg-[#F9A594] transition-colors"
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal; 